import axios from './axios';

const LONG_TIMEOUT = 5 * 60 * 1000;

const platformService = {
  getOverview: async () => {
    const response = await axios.get('/platform/overview');
    return response.data;
  },

  getTenants: async (params = {}) => {
    const response = await axios.get('/platform/tenants', { params });
    return response.data;
  },

  getTenant: async (id) => {
    const response = await axios.get(`/platform/tenants/${id}`);
    return response.data;
  },

  updateTenantStatus: async (id, status) => {
    const response = await axios.put(`/platform/tenants/${id}/status`, { status });
    return response.data;
  },

  updateTenantPlan: async (id, planCode) => {
    const response = await axios.put(`/platform/tenants/${id}/plan`, { plan_code: planCode });
    return response.data;
  },

  assignTenantContract: async (id, data) => {
    const response = await axios.post(`/platform/tenants/${id}/contract`, data);
    return response.data;
  },

  getPlans: async () => {
    const response = await axios.get('/platform/plans');
    return response.data;
  },

  createPlan: async (data) => {
    const response = await axios.post('/platform/plans', data);
    return response.data;
  },

  updatePlan: async (id, data) => {
    const response = await axios.put(`/platform/plans/${id}`, data);
    return response.data;
  },

  deletePlan: async (id) => {
    const response = await axios.delete(`/platform/plans/${id}`);
    return response.data;
  },

  // Full-database backups — long operations get a 5-minute timeout
  // (the instance default is 30s), same as the tenant app used to.
  getBackups: async () => {
    const response = await axios.get('/platform/backups');
    return response.data;
  },

  runBackup: async () => {
    const response = await axios.post('/platform/backups/run', {}, { timeout: LONG_TIMEOUT });
    return response.data;
  },

  downloadBackup: async (id) => {
    const response = await axios.get(`/platform/backups/download/${id}`, {
      responseType: 'blob',
      timeout: LONG_TIMEOUT,
    });
    return response.data;
  },

  deleteBackup: async (id) => {
    const response = await axios.delete(`/platform/backups/${id}`);
    return response.data;
  },

  restoreBackup: async (id) => {
    const response = await axios.post(`/platform/backups/${id}/restore`, { confirm: true }, { timeout: LONG_TIMEOUT });
    return response.data;
  },

  uploadAndRestoreBackup: async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await axios.post('/platform/backups/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: LONG_TIMEOUT,
    });
    return response.data;
  },

  updateBackupSettings: async (data) => {
    const response = await axios.put('/platform/backups/settings', data);
    return response.data;
  },

  getAuditLogs: async (params = {}) => {
    const response = await axios.get('/platform/audit-logs', { params });
    return response.data;
  },
};

export default platformService;
